import { render, staticRenderFns } from "./upload-area-download.vue?vue&type=template&id=22588a22&scoped=true"
import script from "./upload-area-download.vue?vue&type=script&lang=js"
export * from "./upload-area-download.vue?vue&type=script&lang=js"
import style0 from "./upload-area-download.vue?vue&type=style&index=0&id=22588a22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22588a22",
  null
  
)

export default component.exports